import { BehaviorSubject } from 'rxjs';

export class CheckAuthToken {
  private static _loggedIn$ = new BehaviorSubject<boolean>(true);
  private static _count$ = new BehaviorSubject<number>(0);

  public static readonly loggedIn$ = CheckAuthToken._loggedIn$.asObservable();
  public static readonly count$ = CheckAuthToken._count$.asObservable();

  public static get loggedIn(): boolean {
    return CheckAuthToken._loggedIn$.value;
  }
  public static set loggedIn(val: boolean) {
    CheckAuthToken._loggedIn$.next(val);
  }

  public static get count(): number {
    return CheckAuthToken._count$.value;
  }
  public static set count(val: number) {
    CheckAuthToken._count$.next(val);
  }
}
